import React from 'react';
import ReactDOM from 'react-dom';
import './assets/scss/index.scss';
import App from './App';
import { BrowserRouter as Router } from 'react-router-dom';

const reactAppData = window.rpReactPlugin || {};
const { appSelector } = reactAppData;
const appAnchorElement = document.querySelector(appSelector);

if (appAnchorElement) {
  ReactDOM.render(
    <Router basename="/fiterr" >
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Router>,
    appAnchorElement
  )
} else {
  ReactDOM.render(
    <Router basename="/fiterr" >
      <React.StrictMode>
        <App />
      </React.StrictMode>
    </Router>,
  document.getElementById('root'));
}